import {Button, Popover} from 'antd';

export const CompleteInvoiceWidget = ({buyer, invoiceItems, onClick, props}) => {
    const numInvoiceItems = Object.keys(invoiceItems).length;
    const isInvoiceEmpty = numInvoiceItems === 0;
    const priceUndefined = Object.values(invoiceItems).reduce((acc, val) => {
        return acc || (val.item.linePrice === undefined || val.item.linePrice === null);
    }, false) === true;
    const buyerIsEmpty = (buyer === undefined) || (buyer === null)

    const popOverBuyer = <div>Select a buyer.</div>
    const popOverEmpty = <div>Add items to the invoice first.  There's nothing to invoice.</div>
    const popOverPrice = <div>Enter a price for each item.  Some items are missing a price.</div>
    const popOverReady = <div>Save the invoice.</div>
    let popOverContent;

    if (buyerIsEmpty) {
        popOverContent = popOverBuyer;
    } else if (isInvoiceEmpty) {
        popOverContent = popOverEmpty;
    } else if (priceUndefined) {
        popOverContent = popOverPrice;
    } else {
        popOverContent = popOverReady;
    }

    const completeButton = <Button onClick={onClick} disabled={buyerIsEmpty || isInvoiceEmpty || priceUndefined}>Complete</Button>

    return <Popover content={popOverContent} placement={'right'}>{completeButton}</Popover>
}